<template>
  <div>
    <div class="change_inform">
      <div class="title">项目信息</div>
      <el-form :inline="true" :model="PurchaseScheme" class="form_table">
        <el-form-item label="采购编号"
          ><span>{{ PurchaseScheme.schemeCode }}</span></el-form-item
        >
        <el-form-item label="项目名称">{{ PurchaseScheme.projectName }}</el-form-item>
        <el-form-item label="投标确认截止时间">{{ PurchaseScheme.tenderConfirmDate }}</el-form-item>
        <el-form-item label="投标截止时间">{{ PurchaseScheme.biddingDeadline }}</el-form-item>
        <el-form-item label="开标时间">{{ PurchaseScheme.bidOpeningDate }}</el-form-item>
        <el-form-item label="招标文件">
          <el-link type="primary" :underline="false" @click.stop="fnDownload(PurchaseScheme.bidFile.fileId, PurchaseScheme.bidFile.fileName)">{{ PurchaseScheme.bidFile.fileName }}</el-link>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    PurchaseScheme: { type: Object }
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    fnDownload(fileId, fileName) {
      let token = window.localStorage.getItem('loginToken')
      var url = '/Common/DownloadFile?FileId=' + fileId + '&token=' + token + '&FileName=' + fileName
      this.downloadfile(this.baseURL + url)
    }
  }
}
</script>

<style scoped></style>
